import {
  GENERATE_REPORT_ASYNC_REQUEST,
  GENERATE_REPORT_ASYNC_SUCCESS,
  GENERATE_REPORT_ASYNC_FAILURE,
  RESET_IS_TRIGGER_GENERATE_REPORT_ASYNC,
  GENERATE_PRESIGNED_URL_REQUEST,
  GENERATE_PRESIGNED_URL_SUCCESS,
  GENERATE_PRESIGNED_URL_FAILURE,
  SET_DDU_LIST,
  FETCH_DATA_FROM_PRESIGNED_URL_SUCCESS,
  FETCH_DATA_FROM_PRESIGNED_URL_REQUEST,
} from '../../actions/types';

export const initialState = {
  reportValue: [],
  generateReportError: false,
  isTriggerGenerateReport: false,
  presignedURL: '',
  generatePresignedURLError: false,
  dduList: [],
  csvData: '',
  isTriggerFetchDataFromPresignedURL: false,
};

export function generateReportReducer(
  state = initialState,
  { type, payload }: { type: string; payload: any }
) {
  switch (type) {
    case GENERATE_REPORT_ASYNC_REQUEST: {
      return {
        ...state,
        generateReportError: false,
        reportValue: [],
        isTriggerGenerateReport: false,
      };
    }

    case GENERATE_REPORT_ASYNC_SUCCESS: {
      return {
        ...state,
        reportValue: payload,
        isTriggerGenerateReport: true,
      };
    }

    case GENERATE_REPORT_ASYNC_FAILURE: {
      return {
        ...state,
        generateReportError: true,
        reportValue: [],
        isTriggerGenerateReport: true,
      };
    }
    case RESET_IS_TRIGGER_GENERATE_REPORT_ASYNC: {
      return {
        ...state,
        generateReportError: false,
        isTriggerGenerateReport: false,
      };
    }
    case GENERATE_PRESIGNED_URL_REQUEST: {
      return {
        ...state,
        presignedURL: '',
        generatePresignedURLError: false,
      };
    }
    case GENERATE_PRESIGNED_URL_SUCCESS: {
      return {
        ...state,
        presignedURL: payload,
      };
    }
    case GENERATE_PRESIGNED_URL_FAILURE: {
      return {
        ...state,
        generatePresignedURLError: true,
      };
    }
    case SET_DDU_LIST: {
      return {
        ...state,
        dduList: payload,
      };
    }
    case FETCH_DATA_FROM_PRESIGNED_URL_REQUEST: {
      return {
        ...state,
        csvData: '',
        isTriggerFetchDataFromPresignedURL: true,
      };
    }
    case FETCH_DATA_FROM_PRESIGNED_URL_SUCCESS: {
      return {
        ...state,
        csvData: payload,
        isTriggerFetchDataFromPresignedURL: false,
      };
    }
    default: {
      return state;
    }
  }
}
